<script>
import ChannelItem from 'dashboard/components/widgets/ChannelItem.vue';
import router from '../../../index';
import PageHeader from '../SettingsSubPageHeader.vue';
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

export default {
  components: {
    ChannelItem,
    PageHeader,
  },
  mixins: [globalConfigMixin],
  data() {
    return {
      enabledFeatures: {},
    };
  },
  computed: {
    account() {
      return this.$store.getters['accounts/getAccount'](this.accountId);
    },
    evolutionChannel() {
      return { key: 'whatsapp', name: 'WhatsApp não Oficial' };
    },
    channelList() {
      const { apiChannelName, apiChannelThumbnail } = this.globalConfig;
      return [
        { key: 'website', name: 'Website' },
        { key: 'facebook', name: 'Messenger' },
        // { key: 'instagram', name: 'Instagram' },
        { key: 'whatsapp', name: 'WhatsApp Oficial' },
        { key: 'zapi', name: 'Z-API' },
        { key: 'sms', name: 'SMS' },
        { key: 'email', name: 'Email' },
        {
          key: 'api',
          name: apiChannelName || 'API',
          thumbnail: apiChannelThumbnail,
        },
        { key: 'telegram', name: 'Telegram' },
        { key: 'line', name: 'Line' },
      ];
    },
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
    }),
  },
  mounted() {
    this.initializeEnabledFeatures();
  },
  methods: {
    async initializeEnabledFeatures() {
      this.enabledFeatures = this.account.features;
    },
    initChannelAuth(channel) {
      const params = {
        sub_page: channel,
        accountId: this.accountId,
      };
      router.push({ name: 'settings_inboxes_page_channel', params });
    },
    initChannelAuthEvolution() {
      router.push({ name: 'settings_inbox_new_evolution' });
    },
  },
};
</script>

<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0">
    <PageHeader class="max-w-4xl" :header-title="$t('INBOX_MGMT.ADD.AUTH.TITLE')" :header-content="useInstallationName(
      $tWithCompany('INBOX_MGMT.ADD.AUTH.DESC'),
      globalConfig.installationName
    )
      " />
    <div class="grid max-w-3xl grid-cols-2 mx-0 my-6 sm:grid-cols-3 lg:grid-cols-4">
      <ChannelItem v-for="channel in channelList" :key="channel.key" :channel="channel"
        :enabled-features="enabledFeatures" @channel-item-click="initChannelAuth" />
      <ChannelItem :channel="evolutionChannel" :enabled-features="enabledFeatures"
        @channel-item-click="initChannelAuthEvolution" />
    </div>
  </div>
</template>
